import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PublicLayout from "./layout/PublicLayout";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import Quiz from "./pages/Quiz";
import Results from "./pages/Results";
import About from "./pages/About";
import Blossoms from "./pages/Blossoms";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";

export default function App() {
    return (
        <Router>
            <ScrollToTop />
            <Routes>
                <Route element={<PublicLayout />}>
                    <Route index path="/" element={<Home />} />
                    <Route path="/quiz" element={<Quiz />} />
                    <Route path="/results/:uuid" element={<Results />} />
                    <Route path="/results" element={<Results />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/blossoms" element={<Blossoms />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="*" element={<NotFound />} />
                </Route>
            </Routes>
        </Router>
    );
}
